export default function CPSelectorTreeBuilderObserver(searchIndex, allActiveSet, searchCustomers)
{
    this.searchIndex = searchIndex;
    this.allActiveSet = allActiveSet;
    this.searchCustomers = searchCustomers;
}

CPSelectorTreeBuilderObserver.prototype.customerNodeAdded = function ( customerNode )
{
    if( this.searchCustomers )
        this.searchIndex.add( customerNode.getValue().name, customerNode.id );
    this.allActiveSet.add( customerNode );
};

CPSelectorTreeBuilderObserver.prototype.projectNodeAdded = function ( projectNode )
{
    this.searchIndex.add( projectNode.getValue().name, projectNode.id );
    this.allActiveSet.add( projectNode );
};

CPSelectorTreeBuilderObserver.prototype.archivedProjectsParentNodeAdded = function ( node )
{
    this.allActiveSet.add(node);
};

CPSelectorTreeBuilderObserver.prototype.archivedCustomersParentNodeAdded = function ( node )
{
    this.allActiveSet.add(node);
};


// WEBPACK FOOTER //
// ./web/js/cp_selector/CPSelectorTreeBuilderObserver.js